import React from 'react'
import { PortfolioCardProps } from '../PortfolioCard'
import { Card, Text, List, ThemeIcon, useMantineTheme, Image, UnstyledButton, Stack } from '@mantine/core'
import { CircleCheck } from 'tabler-icons-react'
import { LazyImage } from 'src/components/common/LazyImage'
import { GooglePlayIcon } from 'src/assets/images'

export interface PortfolioModalContentProps extends PortfolioCardProps {
  close: () => void
}

export const PortfolioModalContent: React.FC<PortfolioModalContentProps> = props => {
  const { name, detailedInfo, image, link } = props
  const theme = useMantineTheme()

  const textColor = theme.colorScheme === 'dark' ? theme.colors.gray[2] : theme.colors.gray[7]
  const borderColor = theme.colorScheme === 'dark' ? '#353535' : 'transparent'

  return (
    <Card radius="md" sx={{ background: 'transparent', border: `1px solid ${borderColor}`, margin: -10 }}>
      <Card.Section
        p="xl"
        sx={{
          '.lazy-load-image-background': {
            width: '100%',
          },
        }}
      >
        <LazyImage
          src={image}
          alt="Norway"
          style={{ height: 200, width: '100%', objectFit: 'cover', borderRadius: theme.radius.md }}
        />
      </Card.Section>

      <Text mb="lg" align="center" size={'xl'} weight={'bold'} color={textColor}>
        {name}
      </Text>

      <List
        spacing="xs"
        size="sm"
        center
        icon={
          <ThemeIcon color="trasnparent" size={24} radius="xl">
            <CircleCheck size={28} color={theme.colors.gray[5]} />
          </ThemeIcon>
        }
      >
        {detailedInfo &&
          detailedInfo.map(detail => (
            <List.Item>
              <Text>{detail}</Text>
            </List.Item>
          ))}
      </List>

      <Stack
        justify="center"
        align="center"
        sx={{
          img: {
            maxHeight: 60,
          },
        }}
      >
        <UnstyledButton
          component="a"
          target="_blank"
          rel="noopener noreferrer"
          href={link}
          variant="subtle"
          color="blue"
          mt={20}
        >
          <Image src={GooglePlayIcon} fit="contain" />
        </UnstyledButton>
      </Stack>
    </Card>
  )
}
